import { Alert, Typography } from '@mui/material'

import React from 'react'

// Empty state for the admin item-preview modes: the fetch settled but there is
// nothing renderable (deleted item, wrong-service data, …). Caller centers it.
const PreviewUnavailable: React.FC<{ detail: string }> = ({ detail }) => (
  <>
    <Alert severity="warning">This item&apos;s details can&apos;t be previewed.</Alert>
    <Typography variant="body2" color="text.secondary">
      {detail}
    </Typography>
  </>
)

export default PreviewUnavailable
